<template>
	<div>
		<div v-if="event.event_status_id === 5 || event.event_status_id === 4">
			<vx-tooltip :text="$t('OnDemand.DistanceToPoint')" position="bottom">
				<span v-show="distance">{{ distance | km_formatter }}</span>
				<vs-progress :percent="percent" :color="color"></vs-progress>
			</vx-tooltip>
		</div>
		<div v-if="event.event_status_id === 6 || event.event_status_id === 7">
			<span>{{ $t("OnDemand.ReachedThePoint") }}</span>
			<vs-progress :percent="100" :color="color"></vs-progress>
		</div>
	</div>
</template>

<script>
import firebase from "firebase/app";
import mapMethods from "@/components/Maps/mapMethods.js";

export default {
	props: {
		event: {
			type: Object,
		},
		color: {
			type: String,
			default: "#28c76f",
		},
	},
	data() {
		return {
			database: firebase.database(),
			resourceTracking: null,
			mapMethods,
			distance: 0,
			percent: 10,
		};
	},
	methods: {
		getResourceTracking() {
			const starCountRef = this.database
				.ref(`tracking/${this.event.company_id}`)
				.orderByChild("resource_id")
				.equalTo("" + this.event.resource_id);

			starCountRef.on("value", (snapshot) => {
				this.resourceTracking = snapshot.val();

				if (this.resourceTracking && Object.values(this.resourceTracking).length > 0) {
					const data = Object.values(this.resourceTracking)[0];
					this.distance = this.mapMethods.getDistanceFromLatLonInKm(
						this.event.cy,
						this.event.cx,
						+data.cy,
						+data.cx
					);
					this.percent = 100 - this.distance <= 0 ? 10 : 100 - this.distance;
				}
			});
		},
	},
	created() {
		if (this.event.event_status_id === 5 || this.event.event_status_id === 4) this.getResourceTracking();
	},
	updated() {
		if (this.event.event_status_id === 5 || this.event.event_status_id === 4) this.getResourceTracking();
	},
};
</script>
